import uuid from 'uuid';

import User from '../classes/User';
import LocalStorage from './LocalStorage';

const local = new LocalStorage();

export default class UserFactory {

    createUser() {

        const existing = local.get('guardianBikesUserId') ? 'no' : 'yes';               
        const id = local.get('guardianBikesUserId') === null ? local.save('guardianBikesUserId', uuid()) : local.get('guardianBikesUserId');
        const email = local.save('guardianBikesUserEmail');
        const date = local.save('guardianBikesUserDate');

        const visits = local.get('guardianBikesUserVisits') ? Number(local.get('guardianBikesUserVisits')) + 1 : 0;
        local.save('guardianBikesUserVisits', visits);

        return new User(id, email, date, existing, visits);

    }

}


// WEBPACK FOOTER //
// ./src/classes/UserFactory.js